import { useLazyQuery } from '@apollo/client'
import regionQuery from 'gql/region.gql'

// export const registerService = async (input_data: any) => {
//   const input = {
//     location_country: input_data.location_country,
//     location_postcode: input_data.location_postcode,
//   }

//   return fetch('https://service-tco.evenergi.com/v1.0/location', {
//     method: 'POST', // or 'PUT'
//     headers: {
//       'Content-Type': 'application/json',
//     },
//     body: JSON.stringify(input),
//   })
// }

export const useDataByCountryCodeLazyService = () => {
  const [getRegionByCode, { data: { region } = [], error, loading, refetch }] =
    useLazyQuery(regionQuery)

  return {
    data: region || [],
    error,
    loading,
    refetch,
    getRegionByCode,
  }
}
